import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays } from "date-fns";
import { Carousel, DatePicker } from "antd";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import bomcontrole from "../../../images/bomcontrole.png";
import assine from "../../../images/assine.png";
import sgg from "../../../images/sgg.png";
import webmail from "../../../images/webmail.png";
import umbler from "../../../images/umbler.png";
import { getDate, getValue } from "../../../services/functions";
import { ViewInput } from "../../../GlobalStyles";

const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

const atalhos = [
  {
    url: "",
    image: bomcontrole,
    height: 45,
    width: "100%",
  },
  {
    url: "",
    image: webmail,
    height: 20,
    width: "80%",
  },
  {
    url: "",
    image: umbler,
    height: 45,
    width: "100%",
  },
  {
    url: "",
    image: sgg,
    height: 32,
    width: "80%",
  },
  {
    url: "",
    image: assine,
    height: 45,
    width: "100%",
  },
];

export default function HomeCliente() {
  const [resume, setResume] = useState([]);
  const [banners, setBanners] = useState([]);
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30));
  const [dateEnd, setDateEnd] = useState(new Date());

  useEffect(() => {
    loadingResume();
    if (!banners.length) {
      loadingBanners();
    }
  }, [dateStart, dateEnd, banners]);

  async function loadingResume() {
    await api
      .post(`/cliente/resume`, {
        start_date: dateStart,
        end_date: dateEnd,
      })
      .then((response) => {
        setResume(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadingBanners() {
    await api
      .get(`/banners-public?type=franqueado`)
      .then((response) => {
        setBanners(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Resumo</h1>
      <ViewInput style={{ width: "100%", maxWidth: 280 }}>
        <p>Alterar Periodo</p>
        <RangePicker
          style={{ width: "100%" }}
          placeholder={["data inicial", "data final"]}
          value={[
            dateStart ? dayjs(dateStart) : "",
            dateEnd ? dayjs(dateEnd) : "",
          ]}
          format={"DD/MM/YYYY"}
          onChange={(value, dateString) => {
            setDateStart(getDate(dateString[0]));
            setDateEnd(getDate(dateString[1]));
          }}
          allowClear={false}
        />
      </ViewInput>
      <div className="resumes">
        {resume.map((item) => {
          return (
            <div className="resume">
              <h4>
                {item.type == "currency"
                  ? getValue(item.value || 0)
                  : item.value}
              </h4>
              <p>{item.name}</p>
            </div>
          );
        })}
      </div>
      {!!banners.length && (
        <Carousel
          autoplay
          style={{
            margin: "10px 0 20px 0",
          }}
        >
          {banners.map((item) => {
            return (
              <img
                src={item.photo_url}
                style={{
                  height: "auto",
                  width: "100%",
                  borderRadius: 10,
                  objectFit: "contain",
                }}
              />
            );
          })}
        </Carousel>
      )}
    </Container>
  );
}
